const SERVICE = 'prescription-service'

// For Admin Panel
const getPrescriptionListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/admin/prescription', params)

// For Admin Panel
const getPrescriptionApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/admin/prescription/${id}`)

// For Admin Panel
const createPrescriptionApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/prescription')

// For Admin Panel
const updatePrescriptionApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/prescription/${id}`)

// For Admin Panel
const deletePrescriptionApi = async (api, id) => api
  .setMethod()
  .delete()
  .setService(SERVICE)
  .process(`/admin/prescription/${id}`)

// For Admin Panel
const updatePrescriptionStatusApi = async (api, id, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/prescription/${id}/status`)

// For Admin Panel
const addPrescriptionValidityApi = async (api, id, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/prescription/${id}/validity`)

const postDoctorPrescriptionSearchValueApi = async (api, params = {}) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .process('/doctor/medicine', params)

const postDoctorPrescriptionDataApi = async (api, body, id) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/prescription/${id}/item`)

const getPatientPrescriptionDataApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/prescription/${id}`)

const getDoctorPrescriptionNewLinkApi = async (api, params = {}, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/user/${id}/pdf`, params)

const postDoctorEditPrescriptionSearchValueApi = async (api, params = {}) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .process('/doctor/medicine', params)

const postForPrescriptionNotificationDataApi = async (api, body, params = {}) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/prescription/notification', params)

module.exports = {
  // For Admin Panel
  getPrescriptionListApi,
  getPrescriptionApi,
  createPrescriptionApi,
  updatePrescriptionApi,
  deletePrescriptionApi,
  updatePrescriptionStatusApi,
  addPrescriptionValidityApi,

  // ==
  postDoctorPrescriptionSearchValueApi,
  postDoctorPrescriptionDataApi,
  getPatientPrescriptionDataApi,
  getDoctorPrescriptionNewLinkApi,
  postDoctorEditPrescriptionSearchValueApi,
  postForPrescriptionNotificationDataApi,
}
